module.exports = __webpack_public_path__ + "img/upload-nuvem.95912642.svg";